import Vue from 'vue'

// Mobile Saúde Vue UI
// Componentes para o Vue.js 2.x, integrado com o Element UI.
// https://www.npmjs.com/package/@mobilesaude/vue-element-ui
import MobileSaudeVueUI from '@mobilesaude/vue-element-ui'

// Vee Validate
// Simple Vue.js input validation plugin https://baianat.github.io/vee-validate/
// https://github.com/baianat/vee-validate
import VeeValidate from './plugins/vee-validate'

import Clipboard from 'v-clipboard'

// Vue Moment
// Handy Moment.js filters for your Vue.js project.
// https://github.com/brockpetrie/vue-moment
import VueMoment from 'vue-moment'

import Plugins from './plugins'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

// Mobile Saúde Vue UI CSS
import '@mobilesaude/vue-element-ui/dist/vue-element-ui.css'

// Global
import './assets/css/app.less'
import App from './App.vue'
import router from './Router'
import store from './Store'

// PWA
// import './registerServiceWorker'

import ICS from 'vue-ics'

// Não avisar sobre o uso da versão dev do Vue em desenvolvimento.
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Chart.plugins.register(ChartDataLabels)
Vue.use(MobileSaudeVueUI, { env: process.env.NODE_ENV })
Vue.use(VeeValidate)
Vue.use(Plugins)
Vue.use(ICS)
Vue.use(VueMoment, require('moment-timezone'))
Vue.use(Clipboard)

const VueApp = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default VueApp

window.versao_build = `${process.env.NODE_ENV.slice(0, 3).toUpperCase()}-${process.env.VUE_APP_VERSAO_BUILD}`
